import styled from "styled-components";
import { Container } from "@mui/material";

export const ContainerError = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
